import { inject, Injectable } from '@angular/core';
import { UserManagementService } from '../../api/user-management/user-management.service';
import { map, Observable, take } from 'rxjs';
import { User } from '../../../shared/models/api/user';

@Injectable({
  providedIn: 'root',
})
export class UserManangementService {
  apiService = inject(UserManagementService);

  getUserPermissions(userId: string): Observable<string[]> {
    return this.apiService.getUserPermissions(userId).pipe(take(1));
  }

  getNodeUsers(nodeIdNo: string): Observable<User[]> {
    return this.apiService.getNodeUsers(nodeIdNo).pipe(take(1));
  }

  addNodeUser(dto: User): Observable<User> {
    return this.apiService.addUser(dto).pipe(take(1));
  }

  assignUserToNode(userId: string, nodeIdNo: string): Observable<string> {
    return this.apiService.assignUserToNode(userId, nodeIdNo).pipe(take(1));
  }

  updateUser(dto: User, userId: string): Observable<string> {
    return this.apiService.updateUser(dto, userId).pipe(take(1));
  }

  updateUserPin(
    dto: {
      newPassword: string;
    },
    userId: string
  ): Observable<string> {
    return this.apiService.updateUserPin(dto, userId).pipe(take(1));
  }

  deleteUserFromNode(userIdNo: string, nodeIdNo: string): Observable<string> {
    return this.apiService.deleteUserFromNode(userIdNo, nodeIdNo).pipe(take(1));
  }
}
